import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function PublicBookProfileSumPDF() {
  const [book, setBook] = useState(undefined);
  const { id } = useParams();
  const { REACT_APP_BOOKS, REACT_APP_TRANSACCIONES } = process.env;

  // Usar la URL directamente en el iframe en vez de descargar el blob completo
  // Esto permite streaming nativo del browser y evita net_err con PDFs grandes
  const pdfUrl = book?._id
    ? `${REACT_APP_TRANSACCIONES}pubdownload/${book._id}`
    : "";

  function localreload() {
    if (id) {
      fetch(`${REACT_APP_BOOKS}pubbiblioteca/${id}`)
        .then(async (resp) => {
          if (resp.ok) {
            return resp.json();
          } else {
            const error = await resp.json();
            throw new Error(error.message || "Algo ha salido mal");
          }
        })
        .then((resp) => setBook(resp))
        .catch((e) => console.log(e));
    }
  }

  useEffect(() => {
    localreload();
  }, [id]);

  return (
    <>
      {!book ? (
        <div className="w-full h-screen p-6 text-lg font-medium text-gray-600 dark:text-gray-400 dark:bg-gray-900">
          Loading...
        </div>
      ) : (
        <>
          {book.almacenamiento !== "Físico" ? (
            pdfUrl ? (
              <iframe
                src={pdfUrl}
                width="100%"
                height="1200px"
                title="PDF Viewer"
              />
            ) : (
              <>Cargando libro...</>
            )
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
}
